var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStudent1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "105mm",
    height: "74mm",
    viewBox: "0 0 105 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2693.57 271.371h-48.98v50.168h48.98v-50.168",
    style: {
      fill: "#ffe5ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.0631 0 0 -.0631 -106.128 89.908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2557.27 563.809 98.36 53.089c23.98-161.328 30.39-255.316 37.94-295.359l-46.54-18.898c-16.87 58.808-63.44 173.3-89.76 261.168",
    style: {
      fill: "#ffe5ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.0631 0 0 -.0631 -106.128 89.908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2697.5 252.602-58.89 1.457.94 38.582 58.89-1.469-.94-38.57",
    style: {
      fill: "#2bb673",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.0631 0 0 -.0631 -106.128 89.908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2641.1 303.051 56.32-1.391.22 8.16-56.35 1.41-.19-8.179",
    style: {
      fill: "#208956",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.0631 0 0 -.0631 -106.128 89.908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2504.34 585.16-109.28 23.57c21.93-161.621 43.48-258.91 47.4-299.449h48.44c-.17 61.211 12.62 184.16 13.44 275.879m-61.88-281.762c.92-9.609 1.36-14.808 1.36-14.808h47.13s0 5.34-.05 14.808h-48.44",
    style: {
      fill: "#ffe5ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.0631 0 0 -.0631 -106.128 89.908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2437.07 252.09h58.91v38.57h-58.91v-38.57",
    style: {
      fill: "#2bb673",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.0631 0 0 -.0631 -106.128 89.908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2494.69 301.129h-56.35v8.152h56.35v-8.152",
    style: {
      fill: "#208956",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.0631 0 0 -.0631 -106.128 89.908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2682.89 544.859h-319.63v67.68h319.63v-67.68",
    style: {
      fill: "#52bbe7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.0631 0 0 -.0631 -106.128 89.908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2619.35 743.711-87.9 17.93-96.73-17.93c-63.68-48.691-63.68-190.313-63.68-190.313l322.03-10.347s-2.43 136.949-73.72 200.66",
    style: {
      fill: "#52bbe7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.0631 0 0 -.0631 -106.128 89.908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2949.45 254.492h49.4V648.48h-49.4V254.492m-754.05 0h-49.38V648.48h49.38V254.492",
    style: {
      fill: "#855c39",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.0631 0 0 -.0631 -106.128 89.908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2968.93 570.141h-805.34V684.43h805.34V570.141",
    style: {
      fill: "#855c39",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.0631 0 0 -.0631 -106.128 89.908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2998.85 627.281h-852.83v81.938h852.83v-81.938",
    style: {
      fill: "#9d7d61",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.0631 0 0 -.0631 -106.128 89.908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2870.02 697.32c1.35-8.238 9.1-13.859 17.38-12.519 8.3 1.308 13.89 9.07 12.58 17.347l-.18.883-29.92-4.832.14-.879",
    style: {
      fill: "#f26522",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.0631 0 0 -.0631 -106.128 89.908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2869.88 698.199 29.92 4.832-2.69 16.91-29.94-4.82 2.71-16.922",
    style: {
      fill: "#808285",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.0631 0 0 -.0631 -106.128 89.908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2867.17 715.121 29.94 4.82-24.59 152.5-29.94-4.82 24.59-152.5",
    style: {
      fill: "#f26522",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.0631 0 0 -.0631 -106.128 89.908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2841.8 872.52.78-4.899 29.94 4.82-.7 4.219-12.84 25.738-13.06-2.089-4.12-27.789",
    style: {
      fill: "#f1f2f2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.0631 0 0 -.0631 -106.128 89.908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2845.92 900.309 13.06 2.089-9.82 19.711z",
    style: {
      fill: "gray",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.0631 0 0 -.0631 -106.128 89.908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2978.07 889.262c2.57 7.949-.84 16.207-7.72 18.457-6.87 2.261-14.51-2.367-17.15-10.321l-.27-.859 24.86-8.141.28.864m-.28-.864-24.86 8.141-5.33-16.269 24.88-8.141 5.31 16.269",
    style: {
      fill: "#f26522",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.0631 0 0 -.0631 -106.128 89.908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2972.48 872.129-24.88 8.141-48.09-146.79 24.84-8.128 48.13 146.777",
    style: {
      fill: "#379bc2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.0631 0 0 -.0631 -106.128 89.908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2922.81 720.602 1.54 4.75-24.84 8.128-1.35-4.05-1.5-28.41 10.84-3.54 15.31 23.122",
    style: {
      fill: "#ffdeb5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.0631 0 0 -.0631 -106.128 89.908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2907.5 697.48-10.84 3.54-1.19-21.739z",
    style: {
      fill: "#808285",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.0631 0 0 -.0631 -106.128 89.908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2962.07 774.672h-79.49v-118.34h47.38l32.11 118.34",
    style: {
      fill: "#72c476",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.0631 0 0 -.0631 -106.128 89.908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2832.15 774.672h79.43v-118.34h-47.36l-32.07 118.34",
    style: {
      fill: "#72c476",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.0631 0 0 -.0631 -106.128 89.908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2633.89 960.621v37.777l-53.56 7.322h-94.2l-66.01-8.939v-36.16l-14.34-15.562 4.68-20.797h245.36l-21.93 36.359",
    style: {
      fill: "#ffe5ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.0631 0 0 -.0631 -106.128 89.908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2572.05 1314.65s5.07 81.27-36.37 86.91c0 0 45.98 38.73 67.63-18.84 21.65-57.47-25.09-87.45-31.26-68.07",
    style: {
      fill: "#fbb040",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.0631 0 0 -.0631 -106.128 89.908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2580.74 1292.95s-6.35 125.29 82.48 131.5c88.85 6.27 94.73-80.88 81.06-177.75-13.68-96.45 70.21-50.94 70.21-50.94s-79.45-71.93-116.95 11.52c-37.44 83.46-18.56 144.01-43.22 142.39-24.73-1.57-50.94-64.38-50.94-64.38l-22.64 7.66",
    style: {
      fill: "#fbb040",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.0631 0 0 -.0631 -106.128 89.908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2542.4 1271.45s41.19-62.23 55.74-65.85c0 0 34.32 49.2 28.46 74.4-5.9 25.23-54.14 51.29-73.57 37.07-14.03-10.2-19.87-32.17-10.63-45.62",
    style: {
      fill: "#fc868c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.0631 0 0 -.0631 -106.128 89.908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2414.99 1290.43s-27.61 76.64 10.61 93.63c0 0-54.99 24.32-59.7-36.99-4.69-61.29 48.58-76.93 49.09-56.64",
    style: {
      fill: "#fbb040",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.0631 0 0 -.0631 -106.128 89.908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2412.7 1267.17s-28.99 122.11-116.01 103.24c-86.99-18.85-68.29-104.16-28.04-193.32 40.12-88.91-53.15-68.63-53.15-68.63s96.39-46.84 109.02 43.79c12.63 90.62-22.45 143.49 1.7 148.86 24.16 5.34 66.91-47.56 66.91-47.56l19.57 13.62",
    style: {
      fill: "#fbb040",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.0631 0 0 -.0631 -106.128 89.908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2455.52 1257.27s-22.12-71.27-35.1-78.81c0 0-46.7 37.63-48.09 63.49-1.36 25.78 37.6 64.36 60.23 56.14 16.33-5.86 28.07-25.26 22.96-40.82",
    style: {
      fill: "#fc868c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.0631 0 0 -.0631 -106.128 89.908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2662.17 1174.26c10.62-74.36-48.99-144.4-133.17-156.41-84.18-12.01-160.99 38.52-171.62 112.89-10.6 74.32 48.99 144.34 133.22 156.33 84.15 12.05 160.96-38.48 171.57-112.81",
    style: {
      fill: "#ffe5ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.0631 0 0 -.0631 -106.128 89.908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2465.02 1055.22c27.29 3.86 34.82 29.7 31.73 51.52l-76.6-10.96c3.13-21.8 18.78-44.3 44.87-40.56",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.0631 0 0 -.0631 -106.128 89.908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2585.51 1273.4s28.81-85.49 72.07-108.65c43.26-23.11-12.52 129.43-72.07 108.65",
    style: {
      fill: "#fbb040",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.0631 0 0 -.0631 -106.128 89.908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2414.11 1159.06c1.24-8.77-4.66-16.91-13.17-18.14-8.48-1.23-16.46 4.98-17.7 13.75-1.27 8.83 4.66 16.91 13.14 18.14 8.51 1.23 16.45-4.92 17.73-13.75",
    style: {
      fill: "#414042",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.0631 0 0 -.0631 -106.128 89.908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2406.23 1161.82c.52-3.64-1.93-7-5.5-7.48-3.5-.53-6.79 1.99-7.31 5.66-.52 3.61 1.93 7.03 5.43 7.52 3.57.49 6.86-2.07 7.38-5.7",
    style: {
      fill: "#f1f2f2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.0631 0 0 -.0631 -106.128 89.908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2485.85 1162.68c1.26-8.75 9.21-14.95 17.72-13.75 8.54 1.23 14.38 9.41 13.11 18.18-1.24 8.81-9.11 14.96-17.65 13.73-8.5-1.21-14.43-9.34-13.18-18.16",
    style: {
      fill: "#414042",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.0631 0 0 -.0631 -106.128 89.908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2492.62 1167.52c.53-3.61 3.85-6.17 7.38-5.67 3.52.49 5.98 3.87 5.45 7.5-.53 3.62-3.81 6.24-7.32 5.73-3.54-.51-6-3.91-5.51-7.56",
    style: {
      fill: "#f1f2f2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.0631 0 0 -.0631 -106.128 89.908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2555.61 1133.57c1.56-10.78 13.42-18.12 26.5-16.23 13.09 1.88 22.42 12.19 20.9 23.01-1.56 10.84-13.4 18.09-26.51 16.21-13.08-1.85-22.44-12.15-20.89-22.99",
    style: {
      fill: "#fdb5ac",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.0631 0 0 -.0631 -106.128 89.908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2390.43 1105.57c1.69-11.92-6.28-22.95-17.79-24.57-11.52-1.65-22.24 6.7-23.93 18.59-1.71 11.88 6.27 22.87 17.77 24.51 11.52 1.66 22.24-6.66 23.95-18.53m247.05 35.27c1.72-11.93 12.4-20.27 23.93-18.61 11.52 1.64 19.51 12.63 17.79 24.55-1.68 11.87-12.42 20.17-23.93 18.55-11.52-1.64-19.45-12.63-17.79-24.49",
    style: {
      fill: "#ffe5ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.0631 0 0 -.0631 -106.128 89.908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2447.53 1213.46c-14.5-2.07-26.24-9.03-31.45-17.46 0 0 14.37 11.03 32.02 13.59 18.5 2.62 34.51-4.1 34.51-4.1-7.4 6.62-20.55 10.04-35.08 7.97",
    style: {
      fill: "#fbb040",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.0631 0 0 -.0631 -106.128 89.908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2504.06 1030.22 7.8-54.708 45.46 6.457-7.8 54.751-45.46-6.5",
    style: {
      fill: "#ffe5ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.0631 0 0 -.0631 -106.128 89.908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2495.66 1204.43c-14.57-2.09-26.27-9.02-31.44-17.48 0 0 14.32 11.06 32.01 13.58 18.48 2.65 34.47-4.06 34.47-4.06-7.34 6.62-20.52 10.03-35.04 7.96",
    style: {
      fill: "#754c29",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.0631 0 0 -.0631 -106.128 89.908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2539.88 1316.62c-32.11 10.41-83.46 11.21-136.38-35.57-12.69-11.21-20.59-33.78-30.58-45.54-30.39-35.45-62.94 4.49-62.94 4.49-1.58-17.27 22.08-42.42 35.3-49.65 11.92-6.56 24.56-10.37 37.47-11.97 27.13-3.3 55.57 3.12 82.39 13.98 65.76 26.76 121.34 79.91 121.34 79.91s-5.22 31.03-46.6 44.35",
    style: {
      fill: "#fbb040",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.0631 0 0 -.0631 -106.128 89.908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2649.67 876.191-10.78 45.289-12.78 77.821c60.35-5.43 68.52-39.481 71.25-62.539 2.42-20.492 4.4-50.961 4.4-50.961-29.55-40.391-43.54-11.641-52.09-9.61",
    style: {
      fill: "#ffe5ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.0631 0 0 -.0631 -106.128 89.908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2674.2 757.852c2.26-7.622 31.03-9.282 30.86-1.313-1.49 86.41-3.3 129.262-3.3 129.262l-53.52-2.172s15.69-91.598 25.96-125.777m-340.16 116.757 80.58 44.243 74.17 47.769c-48.63 48.109-82.98 29.43-104.14 14.34-18.87-13.402-90.61-78.441-90.61-78.441-12.07-56.071 32.11-22.051 40-27.911",
    style: {
      fill: "#ffe5ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.0631 0 0 -.0631 -106.128 89.908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2260.76 834.301c-7.27-3.27-27.42 17.238-21.38 22.418 66.03 55.761 99.46 82.601 99.46 82.601l33.64-41.679s-79.24-48.539-111.72-63.34",
    style: {
      fill: "#ffe5ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.0631 0 0 -.0631 -106.128 89.908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2631.78 939.469-11.31-14.508v76.229h11.31v-61.721m-209.4 0 11.33-20.5v82.221h-11.33v-61.721",
    style: {
      fill: "#52bbe7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.0631 0 0 -.0631 -106.128 89.908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2564.8 1287.66s-66.92 37.34-113.46 9.55c-64.52-38.52-59.78-86.41-108.58-85.02 0 0 21.49-31.31 86.22-14.36 50.82 13.32 153.62 59.57 135.82 89.83m41.72 70.19s6.45 74.69 87.15 55.86c54.63-12.81 40.12-111.03 41.84-123.01 0 0-7.15 92.64-56.66 94.52-53.42 1.99-72.33-27.37-72.33-27.37m-234.23-33.42s-27.11 69.89-99.25 29.22c-48.87-27.6-7.47-117.79-5.78-129.8 0 0-19.08 90.95 27.91 106.62 50.7 16.83 77.12-6.04 77.12-6.04",
    style: {
      fill: "#fcc066",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.0631 0 0 -.0631 -106.128 89.908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2527.03 849.59.02-92.481 84.88 8.11 19.67 75.761-104.57 8.61m0 0V748.75l-86.37 21.781-18.28 70.449 104.65 8.61",
    style: {
      fill: "#52bbe7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.0631 0 0 -.0631 -106.128 89.908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2631.6 939.469h-209.01c0-54.239-21.95-79.938-1.5-112.539 18.99-30.309 89.93-11.231 93.6-11.379 1.57-.059 6.58 0 12.43.109 5.79-.109 10.81-.168 12.39-.109 3.65.148 74.61-18.93 93.6 11.379 20.46 32.601-1.51 58.3-1.51 112.539",
    style: {
      fill: "#52bbe7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.0631 0 0 -.0631 -106.128 89.908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2619.35 743.711h-184.63l5.94 26.82h172.66l6.03-26.82m-165.71 208.187c-3.93-2.406-23.13-10.058-25.38-6.136-2.33 3.929 13.17 17.949 17.08 20.41 3.94 2.348 8.94 1.25 11.26-2.731 2.29-3.929 1-9.07-2.96-11.543",
    style: {
      fill: "#fc868c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.0631 0 0 -.0631 -106.128 89.908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2436.19 971.43c.04-4.731-3.51-25.668-7.93-25.668-4.45 0-8.09 20.898-8.11 25.629-.03 4.699 3.55 8.507 7.96 8.55 4.49 0 8.08-3.812 8.08-8.511",
    style: {
      fill: "#fc868c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.0631 0 0 -.0631 -106.128 89.908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2411.02 966c3.96-2.41 19.49-16.309 17.24-20.238-2.31-3.961-21.54 3.578-25.46 6-3.97 2.418-5.3 7.539-3.03 11.519 2.28 3.949 7.3 5.141 11.25 2.719",
    style: {
      fill: "#fc868c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.0631 0 0 -.0631 -106.128 89.908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2402.54 940.961c4.05 2.238 23.63 8.82 25.72 4.801 2.09-4.02-14.08-17.192-18.15-19.391-4.04-2.25-8.99-.801-11.1 3.219-2.12 4.082-.53 9.121 3.53 11.371",
    style: {
      fill: "#fc868c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.0631 0 0 -.0631 -106.128 89.908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2419.02 920.551c.18 4.719 4.79 25.469 9.24 25.211 4.39-.211 7-21.293 6.79-26.012-.25-4.75-4-8.32-8.44-8.191-4.42.261-7.85 4.3-7.59 8.992",
    style: {
      fill: "#fc868c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.0631 0 0 -.0631 -106.128 89.908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2444.38 924.609c-3.75 2.641-18.62 17.321-16.12 21.153 2.44 3.789 21.27-4.731 25.1-7.403 3.79-2.597 4.86-7.847 2.4-11.64-2.48-3.828-7.55-4.77-11.38-2.11",
    style: {
      fill: "#fc868c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.0631 0 0 -.0631 -106.128 89.908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2431.29 940.57c-2.75-1.679-6.4-.8-8.04 2.071-1.69 2.871-.83 6.558 1.95 8.238 2.77 1.781 6.37.84 8.06-1.988 1.66-2.871.75-6.61-1.97-8.321",
    style: {
      fill: "#fce38c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.0631 0 0 -.0631 -106.128 89.908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2600.34 951.898c3.93-2.406 23.16-10.058 25.42-6.136 2.33 3.929-13.16 17.949-17.09 20.41-3.9 2.348-8.92 1.25-11.27-2.731-2.27-3.929-.94-9.07 2.94-11.543",
    style: {
      fill: "#fc868c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.0631 0 0 -.0631 -106.128 89.908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2617.85 971.43c-.04-4.731 3.5-25.668 7.91-25.668 4.45 0 8.1 20.898 8.13 25.629 0 4.699-3.58 8.507-7.99 8.55-4.47 0-8.05-3.812-8.05-8.511",
    style: {
      fill: "#fc868c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.0631 0 0 -.0631 -106.128 89.908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2643.01 966c-3.95-2.41-19.51-16.309-17.25-20.238 2.3-3.961 21.54 3.578 25.47 6 3.95 2.418 5.29 7.539 2.99 11.519-2.23 3.949-7.27 5.141-11.21 2.719",
    style: {
      fill: "#fc868c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.0631 0 0 -.0631 -106.128 89.908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2651.46 940.961c-4.06 2.238-23.59 8.82-25.7 4.801-2.09-4.02 14.09-17.192 18.12-19.391 4.09-2.25 9.01-.801 11.14 3.219 2.11 4.082.51 9.121-3.56 11.371",
    style: {
      fill: "#fc868c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.0631 0 0 -.0631 -106.128 89.908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2635.02 920.551c-.2 4.719-4.81 25.469-9.26 25.211-4.41-.211-6.98-21.293-6.78-26.012.24-4.75 4.01-8.32 8.44-8.191 4.42.261 7.85 4.3 7.6 8.992",
    style: {
      fill: "#fc868c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.0631 0 0 -.0631 -106.128 89.908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2609.61 924.609c3.81 2.641 18.66 17.321 16.15 21.153-2.48 3.789-21.28-4.731-25.13-7.403-3.77-2.597-4.83-7.847-2.38-11.64 2.49-3.828 7.58-4.77 11.36-2.11",
    style: {
      fill: "#fc868c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.0631 0 0 -.0631 -106.128 89.908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2622.74 940.57c2.81-1.679 6.38-.8 8.06 2.071 1.68 2.871.76 6.558-1.97 8.238-2.81 1.781-6.36.84-8.06-1.988-1.65-2.871-.77-6.61 1.97-8.321",
    style: {
      fill: "#fce38c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.0631 0 0 -.0631 -106.128 89.908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2262.11 866.68c-36.67 34.14-93.56 47.75-151.62 84.55-4.93 3.09-.42 7.911-11.41 19.899-7.93 8.621-21.68 26.902-25.84 25.203-5.88-2.523 6.34-27.133 3.29-25.531-7.59 3.949-23.6 12.578-26.16 14.449-2.96 2.148-15.4 31.76-20.14 28.56-5.13-3.44 4.27-20.259 5.4-22.701 6.63-14.531 10.58-20.168 12.76-22.461 2.59-2.668 40.43-31.007 40.43-31.007s90.14-67.309 156.37-100c14.24-7.039 23.22 23.14 16.92 29.039m422.5-91.66c-48.11-13.809-89.16-55.528-150.65-86.309-5.15-2.602-6.95 3.73-22.94.531-11.47-2.344-34.2-4.711-34.88-9.16-.9-6.332 4.8-6.023 25.93-6.41 3.46-.063.55-2.133-2.4-3.922-7.29-4.48-22.92-13.75-25.88-14.969-3.39-1.34-35.14 3.211-34.84-2.5.31-6.152 19.53-6.769 22.21-7.082 15.85-1.758 22.79-1.347 25.87-.668 3.61.821 47.42 18.617 47.42 18.617s104.16 42.512 166.31 82.422c13.4 8.532-7.85 31.789-16.15 29.45",
    style: {
      fill: "#ffe5ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.0631 0 0 -.0631 -106.128 89.908)"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudent1);
export default __webpack_public_path__ + "static/media/student1.570e424931392f36b10381c2a5f7a61b.svg";
export { ForwardRef as ReactComponent };